export default __webpack_public_path__ + "media/images/logo_transparent-811b98150520c2666af239c20f2d765d.svg";